<template>
  <div id="cmop_detail" v-loading="loading">
    <div class="main">
      <p>客户许可协议</p>
      <!-- 协议内容绑定方式，将doc另存为HTML，在谷歌浏览器打开HTML，右键查看源代码，全选复制所有代码 -->
      <div class="detail" v-html="htmlContent"></div>
      <el-checkbox v-model="checked" :disabled="$route.params.status === 2">已阅读并同意 客户许可协议</el-checkbox>
      <p>
        <el-button type="primary" size="small" :disabled="!checked" @click="submitEvent">申请开放激活</el-button>
      </p>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
import axios from "axios"; //引用axios

export default {
  name: "cmop_detail",
  methods: {
    submitEvent() {
      var _this = this;
      _this.loading = true;
      post("ecla/open_active/", {
        token: _this.$route.params.token
      }).then(
        res => {
          _this.loading = false;
          _this.$notify.success({
            message: res.msg,
            offset: 70
          });
          _this.$router.push({ name: "cmopLogin" });
        },
        err => {
          _this.loading = false;
          _this.$notify.info({
            message: err.data.msg,
            offset: 70
          });
        }
      );
    }
  },
  beforeCreate() {
    if (!this.$route.params.status || !this.$route.params.token) {
      this.$router.push({ name: "cmopLogin" });
    } else {
      console.log(window.location);
      console.log('111222333 this.$route.params.order_type=' + this.$route.params.order_type)
      if (this.$route.params.order_type == 'PCIB' || this.$route.params.order_type == '批量激活') {
        axios
          .get(
            window.location.protocol +
            "//" +
            window.location.host +
            "/static/files/ECLA_doc.html",
            {baseURL: ""}
          )
          .then(rs => {
            this.htmlContent = rs.data.replace(/<img[^<>]+>/g, "");
          });
      } else if (this.$route.params.order_type == 'VDI') {
        axios
          .get(
            window.location.protocol +
            "//" +
            window.location.host +
            "/static/files/ECLA_VDI_doc.html",
            {baseURL: ""}
          )
          .then(rs => {
            this.htmlContent = rs.data.replace(/<img[^<>]+>/g, "");
          });
      }
    }
  },
  mounted() {
    if (this.$route.params.status === 2) {
      this.checked = true;
    }
  },
  data() {
    return {
      checked: false,
      loading: false,
      htmlContent: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cmop/CmopDetail.vue